import React from "react";
import Header from "./header/Header";
import Body from "./body/Body";
import Footer from "./footer/Footer";

// App owns the global drawer and profile bootstrap; do not mount them twice.
const Main = () => (
    <div className="relative">
        <Header />
        <Body />
        <Footer />
    </div>
);

export default Main;
